import {
  actions as _spinActions,
  reducer as _spinReducer,
} from './SPIN';
import {
  actions as _coreActions,
  reducer as _coreReducer,
} from './CoreAndCatchUp';
import {
  actions as _essayActions,
  reducer as _essayReducer,
  Essay as _Essay,
} from './Essay';
import {
  actions as _shortAnswerActions,
  reducer as _shortAnswerReducer,
} from './ShortAnswer';
import * as _activityActions from './Activity/actions';
import * as _commentsActions from './Comments/actions';
import * as _accessors from './accessors';
import _status from './status';

export const spinActions = _spinActions;
export const coreActions = _coreActions;
export const essayActions = _essayActions;
export const spinReducer = _spinReducer;
export const coreReducer = _coreReducer;
export const essayReducer = _essayReducer;
export const shortAnswerActions = _shortAnswerActions;
export const shortAnswerReducer = _shortAnswerReducer;
export const activityActions = _activityActions;
export const commentsActions = _commentsActions;
export const accessors = _accessors;
export const status = _status;
export const Essay = _Essay;



// WEBPACK FOOTER //
// ./data/WritingAssignment/index.js